// components/Tables/BillingTable.js
import React from 'react';

const BillingTable = ({ data = [] }) => {
  return (
    <div className="table-responsive">
      <table className="table table-history mb-0">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Сума</th>
            <th>Тип нарахування</th>
            <th>Опис</th>
          </tr>
        </thead>
        <tbody>
          {data.map((bill, index) => (
            <tr key={index}>
              <td>{new Date(bill.date).toLocaleDateString('uk-UA')}</td>
              <td>{bill.amount} грн.</td>
              <td>{bill.type}</td>
              <td>{bill.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BillingTable;